module.exports = __webpack_public_path__ + "static/media/decoracion_arriba.bf78e1ce.svg";